import {
  CHECKLIST_REFERENCES_CREATE,
  ACTUAL_STATE_IMAGES_SAVE,
  SET_SIGN_CHECKLIST_TRANSPORTIST,
  SET_SIGN_CHECKLIST_RECEPTOR,
  CHECKLIST_DATA_UPDATE,
  MAIN_CHECKLIST_ARRAY_GET,
  FUEL_ARRAY_GET,
  HOROMETRO_SET_DATA,
  HOROMETRO_RESET_DATA,
  ACTUAL_STATE_IMAGES_GET,
  CHECKLIST_ITEM_DATA_GET,
  CHECKLIST_DATA_RESET,
  SAVE_STATUS_DETAIL,
  ODOO_CHECKLIST_URL_SAVE,
  SET_ORDER_DATA,
  CHECKLIST_REFERENCE_TRANSFER,
  FUEL_ARRAY_RESET,
  SET_CHECKLIST_DATA,
  UPDATE_STATE_CHECKLIST,
  SET_BRANCH_DATA,
  SET_EMAILS_NOTIFICATIONS
} from "./mutation-types";
import * as localforage from "localforage";

export default {
  [CHECKLIST_REFERENCES_CREATE](state, data) {
    state.productRef = data.productRef;
    state.eventRef = data.eventRef;
    state.checklistRef = data.checklistRef;
  },
  [SET_BRANCH_DATA](state, data) {
    state.branchs = data;
  },
  [CHECKLIST_REFERENCE_TRANSFER](state, checklistRef) {
    state.checklistRef = checklistRef;
    state.itemsSavedActualState = [];
  },
  [ACTUAL_STATE_IMAGES_SAVE](state, imagesObject) {
    state.checklistRef.get().then(checklistExists => {
      if (!checklistExists.exists) {
        state.checklistRef.set(imagesObject);
      } else {
        state.checklistRef.update(imagesObject);
      }
    });
    // clear local forage impormation to free user's memory
    localforage.clear();
  },
  [SET_SIGN_CHECKLIST_TRANSPORTIST](state, data) {
    state.signChecklistDeliverer = data;
  },
  [SET_SIGN_CHECKLIST_RECEPTOR](state, data) {
    state.signChecklistReceiver = data;
  },
  [CHECKLIST_DATA_UPDATE](state, checklist) {
    state.checklistArray = state.checklistArray.map(check => {
      if (check.checklistName == checklist.checklistName) return checklist;
      return check;
    });
  },
  [SET_CHECKLIST_DATA](state, data) {
    const {
      savedChecklists,
      savedFuel,
      machineImages,
      checklistPhysical,
      videos,
      savedHorometro,
      signedChecklistDeliverer,
      signedChecklistReceiver,
      emailNotifications,
      albaran,
      albaranCheckListReason,
      albaranType
    } = data;
    state.checklistArray = savedChecklists;
    state.checklistFuelData = savedFuel;
    state.machineImages = machineImages;
    state.checklistPhysicalImages = checklistPhysical;
    if (videos) state.videos = videos;
    state.emailNotifications = emailNotifications ? emailNotifications : [];
    state.horometro = savedHorometro;
    state.signChecklistDeliverer = signedChecklistDeliverer;
    state.signChecklistReceiver = signedChecklistReceiver;
    state.albaran = albaran;
    state.albaranCheckListReason = albaranCheckListReason;
    state.albaranType = albaranType;
  },
  [UPDATE_STATE_CHECKLIST](state, data) {
    switch (data.type) {
      case "incidence":
        state.checklistArray[data.indexArray].images[data.indexImage].src =
          data.url;
        break;
      case "horometro":
        state.horometro.image = data.url;
        break;
      case "physical":
        state.checklistPhysicalImages.src = data.url;
        break;
      case "machine":
        state.machineImages[data.michineindex].src = data.url;
        break;
    }
  },
  [ACTUAL_STATE_IMAGES_GET](state, checklistData) {
    state.itemsSavedActualState = checklistData.actualStateImages;
  },
  [MAIN_CHECKLIST_ARRAY_GET](state, checklistData) {
    state.checklistQuery = checklistData.savedChecklists;
    state.allChecklistData = checklistData;
  },
  [FUEL_ARRAY_GET](state, fuel) {
    state.checklistFuelData = fuel;
  },
  [HOROMETRO_SET_DATA](state, horometro) {
    state.horometro = horometro;
  },
  [FUEL_ARRAY_RESET](state) {
    state.checklistFuelData = {
      notApply: false,
      value: 0
    };
  },
  [SET_EMAILS_NOTIFICATIONS](state, data) {
    state.emailNotifications = data.emails;
    state.validEmailNotifications = data.valid;
  },
  [HOROMETRO_RESET_DATA](state) {
    state.horometro = {
      notApply: false,
      value: null
    };
  },
  [SET_ORDER_DATA](state, data) {
    state.orderMetadata = data;
  },
  [SAVE_STATUS_DETAIL](state, status) {
    state.statusDetail = {
      machineSerie: status.machineSerie,
      event: status.event,
      inputOuput: status.inputOuput
    };
  },
  [CHECKLIST_ITEM_DATA_GET](state, checklistData) {
    checklistData.data.savedChecklists.forEach(checklist => {
      if (checklist.title == checklistData.title) {
        state.checklistItemData = checklist;
      }
    });
  },
  [CHECKLIST_DATA_RESET](state) {
    state.checklistArray = [
      {
        title: "Switch y llave",
        checklistName: "switchAndKey",
        checked: false,
        incidence: false,
        notApply: false
      },
      {
        title: "Funciones Control terrestre",
        checklistName: "funcionesControlTerrestre",
        checked: false,
        incidence: false,
        notApply: false
      },
      {
        title: "Botones y palancas terrestres",
        checklistName: "botonesPalancaTerrestre",
        checked: false,
        incidence: false,
        notApply: false
      },
      {
        title: "Funciones Control aéreo",
        checklistName: "funcionesControlAereo",
        checked: false,
        incidence: false,
        notApply: false
      },
      {
        title: "Botones y palancas aéreas",
        checklistName: "botonesPlacasAereas",
        checked: false,
        incidence: false,
        notApply: false
      },
      {
        title: "Clavija de alimentación",
        checklistName: "clavijaAlimentacion",
        checked: false,
        incidence: false,
        notApply: false
      },
      {
        title: "Funciones del sistema Hidráulico",
        checklistName: "funcionesSistemaHidraulico",
        checked: false,
        incidence: false,
        notApply: false
      },
      {
        title: "Clavija y funcionamiento del cargador",
        checklistName: "clavijaFuncionamiento",
        checked: false,
        incidence: false,
        notApply: false
      },
      {
        title: "Llantas (estética)",
        checklistName: "llantasEstetica",
        checked: false,
        incidence: false,
        notApply: false
      },
      {
        title: "Cubos reductores libres de playo",
        checklistName: "cubosReductoresLibresPlayo",
        checked: false,
        incidence: false,
        notApply: false
      },
      {
        title: "Rines",
        checklistName: "rines",
        checked: false,
        incidence: false,
        notApply: false
      },
      {
        title: "Baterías (carga óptima)",
        checklistName: "bateriasCargaOptima",
        checked: false,
        incidence: false,
        notApply: false
      },
      {
        title: "Canastilla y barandal (sin alteraciones)",
        checklistName: "canastillaBarandal",
        checked: false,
        incidence: false,
        notApply: false
      },
      {
        title: "Tornillería",
        checklistName: "tornilleria",
        checked: false,
        incidence: false,
        notApply: false
      },
      {
        title: "Pintura de todo el equipo",
        checklistName: "pinturaTodoElEquipo",
        checked: false,
        incidence: false,
        notApply: false
      },
      {
        title: "Limpieza",
        checklistName: "limpieza",
        checked: false,
        incidence: false,
        notApply: false
      },
      {
        title: "Daños visibles en la estructura",
        checklistName: "dañosVisiblesEstructura",
        checked: false,
        incidence: false,
        notApply: false
      },
      {
        title: "Tapa de baterías",
        checklistName: "tapaBaterias",
        checked: false,
        incidence: false,
        notApply: false
      },
      {
        title: "Tapa de tracciones",
        checklistName: "tapaTracciones",
        checked: false,
        incidence: false,
        notApply: false
      },
      {
        title: "Tapa de cargador",
        checklistName: "tapaCargador",
        checked: false,
        incidence: false,
        notApply: false
      },
      {
        title: "Tapa de controles terrestres",
        checklistName: "tapaControlesTerrestres",
        checked: false,
        incidence: false,
        notApply: false
      },
      {
        title: "Tapa del sistema hidráulico",
        checklistName: "tapaSistemaHidraulico",
        checked: false,
        incidence: false,
        notApply: false
      },
      {
        title: "Calcomanías",
        checklistName: "calcomanías",
        checked: false,
        incidence: false,
        notApply: false
      },
      {
        title: "Características y capacidad",
        checklistName: "caracteristicasCapacidad",
        checked: false,
        incidence: false,
        notApply: false
      },
      {
        title: "Responsabilidades del cliente",
        checklistName: "responsabilidadesDelCliente",
        checked: false,
        incidence: false,
        notApply: false
      },
      {
        title: "Tiempos de trabajo 3 x 8",
        checklistName: "tiemposDeTrabajo",
        checked: false,
        incidence: false,
        notApply: false
      },
      {
        title: "Torreta",
        checklistName: "torreta",
        checked: false,
        incidence: false,
        notApply: false
      },
      {
        title: "Extinguidor",
        checklistName: "extinguido",
        checked: false,
        incidence: false,
        notApply: false
      },
      {
        title: "Manual",
        checklistName: "manual",
        checked: false,
        incidence: false,
        notApply: false
      },
      {
        title: "Alarma de movimiento",
        checklistName: "AlarmaDeMovimiento",
        checked: false,
        incidence: false,
        notApply: false
      },
      {
        title: "Revisión de sistema de carga de batería",
        checklistName: "revicionSistemaCargaBateria",
        checked: false,
        incidence: false,
        notApply: false
      },
      {
        title: "Revisión de sistema mecánico y chasis",
        checklistName: "revisionSistemaMecanico",
        checked: false,
        incidence: false,
        notApply: false
      },
      {
        title: "Revisión de GPS",
        checklistName: "revisionGPS",
        checked: false,
        incidence: false,
        notApply: false
      }
    ];
    state.checklistFuelData = {
      notApply: false,
      value: 0
    };
    state.horometro = {
      notApply: false,
      image: null,
      value: null
    };
    state.checklistPhysicalImages = { titleSection: "Frente", src: null };
    (state.videos = {
      titleSection: "Video de checklist",
      src: null,
      file: null
    }),
      (state.emailNotifications = []);
    state.validEmailNotifications = true;
    state.machineImages = [
      { titleSection: "Frente", src: null, id: 1 },
      { titleSection: "Posterior", src: null, id: 2 },
      { titleSection: "Lateral 1", src: null, id: 3 },
      { titleSection: "Lateral 2", src: null, id: 4 },
      { titleSection: "Llanta FD", src: null, id: 5 },
      { titleSection: "Llanta FI", src: null, id: 6 },
      { titleSection: "Lanta PD", src: null, id: 7 },
      { titleSection: "Llanta PI", src: null, id: 8 }
    ];
  },
  [ODOO_CHECKLIST_URL_SAVE](state, savedChecklist) {
    state.lastChecklistSaved = savedChecklist;
  }
};
